import React from 'react';
import { useLocation } from 'react-router-dom';
import SeasonSelector from '../SeasonSelector';
import { findNavItemByPath } from '../../config/navigation';

const MobileTopBar = () => {
  const location = useLocation();
  const navItem = findNavItemByPath(location.pathname);

  return (
    <header className="mobile-top-bar">
      <span className="mobile-top-bar-title">
        {navItem && <i className={ `fas ${navItem.icon}` } />}
        {navItem?.label || 'Farm Manager'}
      </span>
      <SeasonSelector />
    </header>
  );
};

export default MobileTopBar;
